import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { IDialogConfirmationResult } from '@app/main/main-content/display-options/interfaces/dialog-confirmation-result.interface';

@Component({
  selector: 'gc-dialog-apply-filter-confirmation',
  templateUrl: './dialog-apply-filter-confirmation.component.html',
  styleUrl: './dialog-apply-filter-confirmation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Button, Checkbox, FormsModule, SvgIconComponent, TranslatePipe],
})
export class DialogApplyFilterConfirmationComponent implements OnDestroy {
  private ref = inject(DynamicDialogRef);

  public doNotShowAgain = false;

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }

  public cancel(): void {
    this.ref.close({ confirmed: false, doNotShowAgain: false } satisfies IDialogConfirmationResult);
  }

  public apply(): void {
    this.ref.close({
      confirmed: true,
      doNotShowAgain: this.doNotShowAgain,
    } satisfies IDialogConfirmationResult);
  }
}
